export interface LayoutPage {
    id: string;
    name: string;
}

export interface LayoutCategory {
    id: string;
    name: string;
    icon: string;
    pages: LayoutPage[];
}

export interface LayoutWidgetConfig {
    id: string;
    qlcWidgetId: string;
    name: string;
    type: 'button' | 'fader' | 'speed-dial' | 'rgb-matrix' | 'global-color' | 'animation-matrix';
    colSpan: number;
    rowSpan: number;
    color?: string;
    isToggle?: boolean;
    faderMode?: 'dmx' | 'time';
    maxMs?: number;
    linkedWidgetId?: string;
    isLinked?: boolean;
    pageId?: string;
    subWidgets?: LayoutWidgetConfig[];
}

export interface LayoutData {
    version: number;
    updatedAt: number;
    categories?: LayoutCategory[];
    activeCategoryId?: string;
    activePageId?: string;
    widgets: LayoutWidgetConfig[];
}

export const DEFAULT_LAYOUT_CATEGORIES: LayoutCategory[] = [
    {
        id: 'cat-scenes',
        name: 'Scènes',
        icon: 'mdi-theater',
        pages: [
            { id: 'page-scenes-main', name: 'Algemeen' },
        ],
    },
    {
        id: 'cat-color',
        name: 'Kleur',
        icon: 'mdi-palette',
        pages: [
            { id: 'page-color-main', name: 'Algemeen' },
        ],
    },
    {
        id: 'cat-tempo',
        name: 'Tempo',
        icon: 'mdi-metronome',
        pages: [
            { id: 'page-tempo-main', name: 'Algemeen' },
        ],
    },
];
